/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import { events } from '@adobe-commerce/event-bus';
import { fetchGraphQl } from '@/auth/api/fetch-graphql';
import { AdobeCommerceOptimizerModel } from '@/auth/data/models';
import {
  transformAdobeCommerceOptimizerData,
  AdobeCommerceOptimizerResponse,
} from '@/auth/data/transforms';
import { GET_ADOBE_COMMERCE_OPTIMIZER_DATA } from './graphql/getAdobeCommerceOptimizerData.graphql';

/**
 * Fetches Adobe Commerce Optimizer data from GraphQL API
 * This function works for both authenticated and non-authenticated users
 */
export const getAdobeCommerceOptimizerData =
  async (): Promise<AdobeCommerceOptimizerModel> => {
    const response = (await fetchGraphQl(GET_ADOBE_COMMERCE_OPTIMIZER_DATA, {
      method: 'GET',
    })) as AdobeCommerceOptimizerResponse;

    const adobeCommerceOptimizerData = transformAdobeCommerceOptimizerData(response);

    // Emit event with the adobe commerce optimizer data
    events.emit('auth/adobe-commerce-optimizer', adobeCommerceOptimizerData);

    return adobeCommerceOptimizerData;
  };
